import { ReactSelectStyleSmall } from "../common/rectSelectStyle";
import { mouldInputCorrect } from "../../aplUtils/defectsHelper";
import { translateString } from "../../translations/gridTranslationHelper";
import { parseBool } from "../../aplUtils/extensions";
import ReactSelectWrapper from "../common/ReactSeletWrapper";
import AplSettingsSelector from "../../redux/helpers/AplSettingsSelector";
import { PalletDefect } from "../../types/palletDefect";
import { DefectType } from "../../types/defectType";

interface ModalDefectsRowProps {
    defect: PalletDefect;
    dataKey: string;
    handleChange: (arg0: React.ChangeEvent, arg1: string) => void;
    defectTypes: DefectType[];
  
    removeDefectFunc: (arg0: string) => void;
    addDefectFunc: (event: MouseEvent) => void;
  
    defectAddImg: any;
    defectRemoveImg: any;
    lot: string;
    sequenceNo: number;
    siteId: number;
  }

export default function ModalDefectsRow(props: ModalDefectsRowProps) {
    const { defect } = props;
    const originalDefect = { ...defect };
    const aplSettings = AplSettingsSelector();

    const isDefectIdValid = defect.defectId === 0 || originalDefect.initials?.trim()?.length > 0;
    const isCommentValid = defect.defectId === 0 || originalDefect.comment?.trim()?.length > 0 || [19, 20, 21].includes(aplSettings.siteId);

    const defectsData = [
        { value: 0, label: translateString("rxg_Please_select_a_defect", aplSettings.culture) },
        ...props.defectTypes.map(dt => ({
            value: dt.defectId,
            label: `${dt.defectId.toString().padStart(3, "0")} ${dt.defectName}`,
            disabled: parseBool(dt.deprecated)
        }))
    ];

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        props.handleChange(e, props.dataKey);
    };

    return (
        <tr className="defect-row" data-key={props.dataKey} key={props.dataKey}>
            <td>{aplSettings.siteId === 7 ? props.lot + '-' + props.sequenceNo : originalDefect.sscc}</td>
            <td>
                <ReactSelectWrapper
                    data={defectsData}
                    isClearable={false}
                    styles={ReactSelectStyleSmall}
                    onChange={e => {
                        props.handleChange({ target: { name: "defectId", value: e.value } } as any, props.dataKey);
                    }}
                    value={defectsData.find(x => x.value === defect?.defectId) ?? null}
                    isDisabled={false}
                />
            </td>
            <td>
                <input
                    name="mouldNo"
                    id={`defect-mould-number-${props.dataKey}`}
                    className={`form-control form-control-sm ${mouldInputCorrect(originalDefect.mouldNo) ? "" : "is-invalid"}`}
                    style={{ width: "120px" }}
                    maxLength={20}
                    type="text"
                    defaultValue={originalDefect.mouldNo}
                    onChange={handleChange}
                />
            </td>
            <td>
                <input
                    name="initials"
                    id={`defect-initial-${props.dataKey}`}
                    className={`form-control form-control-sm ${isDefectIdValid ? "" : "is-invalid"}`}
                    style={{ width: "60px" }}
                    type="text"
                    maxLength={6}
                    value={originalDefect.initials}
                    onChange={handleChange}
                />
            </td>
            <td>
                <input
                    name="comment"
                    id={`defect-comment-${props.dataKey}`}
                    className={`form-control form-control-sm ${isCommentValid ? "" : "is-invalid"}`}
                    style={{ width: "320px" }}
                    type="text"
                    value={originalDefect.comment}
                    onChange={handleChange}
                />
            </td>
            <td className="hideme">
                <input type="text" defaultValue="0000000" />
            </td>
            <td>
                <img alt={"Add Defect"} src={props.defectAddImg} onClick={props.addDefectFunc as any} />
            </td>
            <td>
                <img alt={"Remove Defect"} src={props.defectRemoveImg} onClick={() => props.removeDefectFunc(props.dataKey)} />
            </td>
            <td className="hideme">1</td>
        </tr>
    );
}
